import React from "react"

import { useGridCell } from "./useGridCell"

interface InputCellWrapperProps {
  width: string
  isExpanded: boolean
  hasPendingEdit?: boolean
  isDisabled?: boolean
  ariaLabel: string
  /** Stable marker for locating this cell (e.g. to focus it after adding a row). */
  cellRole?: string
  children:
    | React.ReactNode
    | ((opts: { isEditing: boolean; isExpanded: boolean }) => React.ReactNode)
}

/** Shared table cell wrapper. First click focuses (ring), second click enters edit mode. */
export const InputCellWrapper: React.FC<InputCellWrapperProps> = ({
  width,
  isExpanded,
  isDisabled = false,
  ariaLabel,
  cellRole,
  children,
}) => {
  const { isEditing, cellProps } = useGridCell({
    ariaLabel,
    disabled: isDisabled,
  })

  return (
    <td
      {...cellProps}
      data-cell-role={cellRole}
      className="p-0 outline-none"
      style={{ width, padding: 0, verticalAlign: "top" }}
    >
      <div className="px-2 pt-4 pb-2">
        {typeof children === "function"
          ? children({ isEditing, isExpanded })
          : children}
      </div>
    </td>
  )
}
